const it = {
  common: {
    loading: "Caricamento...",
    error: "Errore nel caricamento dei dati",
    noData: "Nessun dato disponibile",
    retry: "Riprova",
    close: "Chiudi",
    save: "Salva",
    cancel: "Annulla",
    all: "Tutti",
    search: "Cerca",
    filter: "Filtro",
    sport: "Sport",
    tennis: "Tennis",
    table_tennis: "Tennistavolo",
    view_details: "Vedi Dettagli",
    view_match: "Vedi Incontro",
    back: "Indietro",
    yes: "Si",
    no: "No",
    right: "Destra",
    left: "Sinistra",
    cm: "cm",
    years: "anni",
    on: "su",
    profile: "Profilo",
    details: "Dettagli",
    players_count: "giocatori",
    no_data_available: "Dati non disponibili",
  },
  nav: {
    dashboard: "Dashboard",
    prematch_signals: "Segnali Prematch",
    live_signals: "Segnali Live",
    matches: "Incontri",
    players: "Giocatori",
    notifications: "Notifiche",
    settings: "Impostazioni",
  },
  status: {
    live: "Live",
    upcoming: "Prossimo",
    scheduled: "Programmato",
    finished: "Terminato",
    active: "Attivo",
    won: "Vinto",
    lost: "Perso",
  },
  dashboard: {
    title: "Dashboard",
    subtitle: "Panoramica delle opportunita di valore",
    prematch_today: "Segnali Prematch",
    live_today: "Segnali Live",
    live_matches: "Incontri Live",
    alerts_today: "Alert Inviati",
    top_opportunities: "Top Opportunita del Giorno",
    recent_live: "Match Attualmente Live",
    no_opportunities: "Nessuna opportunita disponibile",
    no_live_matches: "Nessun match in corso",
    all_signals: "Tutti i segnali",
    all_matches: "Tutti gli incontri",
    // Engine prematch
    prematch_engine: "Prematch Engine",
    best_ev_today: "Miglior EV di Oggi",
    max_confidence: "Massima Confidenza",
    watch_live: "Da Seguire Live",
    no_engine_signal: "Nessun segnale engine",
    no_match_to_follow: "Nessun match da seguire",
    // Engine live
    live_engine: "Live Engine",
    live_signals_active: "Segnali Live Attivi",
    best_ev_live: "Miglior EV Live",
    strongest_momentum: "Momentum Piu Forte",
    no_live_signal: "Nessun segnale live",
    no_momentum: "Nessun momentum rilevante",
    on_matches: "su {count} match live",
    // Table
    th_match: "Incontro",
    th_sport: "Sport",
    th_signal: "Segnale",
    th_bookmaker: "Bookmaker",
    th_odds: "Quota",
    th_ev: "EV",
  },
  signals: {
    prematch_title: "Segnali Prematch",
    prematch_subtitle: "Analisi di valore pre-partita",
    live_title: "Segnali Live",
    live_subtitle: "Segnali in tempo reale durante i match",
    all_sports: "Tutti gli sport",
    all_status: "Tutti gli stati",
    match: "Incontro",
    sport: "Sport",
    time: "Orario",
    market: "Mercato",
    signal: "Segnale",
    selection: "Selezione",
    odds: "Quota",
    odds_bk: "Quota BK",
    odds_fair: "Quota Fair",
    odds_live: "Quota Live",
    fair_odds: "Quota Equa",
    bookmaker: "Bookmaker",
    ev: "EV",
    ev_pct: "EV %",
    value_score: "Punteggio Valore",
    confidence: "Confidenza",
    analysis: "Analisi",
    status: "Stato",
    score: "Punteggio",
    momentum: "Momentum",
    pressure: "Pressione",
    alert_type: "Tipo Alert",
    detected: "Rilevato",
    no_signals: "Nessun segnale disponibile",
    total_signals: "Segnali totali",
    active_only: "Solo attivi",
    won_only: "Solo vinti",
    lost_only: "Solo persi",
    watch_live: "Da Seguire",
    match_live: "Match Live",
    // Engine buttons
    run_prematch: "Esegui Engine Prematch",
    run_live: "Esegui Engine Live",
    running: "Analisi in corso...",
    engine_complete: "Engine completato",
    live_engine_complete: "Engine Live completato",
    matches_analyzed: "match analizzati",
    new_signals: "nuovi segnali",
    updated: "aggiornati",
    // Expanded details
    estimated_prob: "Prob. Stimata",
    fair_label: "Fair",
    follow_live: "Da seguire live",
    generated_by_prematch: "Generato da Prematch Engine",
    generated_by_live: "Generato da Live Engine",
  },
  momentum: {
    positive: "Positivo",
    negative: "Negativo",
    neutral: "Neutro",
  },
  alert_type: {
    momentum_shift: "Cambio Momentum",
    value_detected: "Valore Rilevato",
    pattern_detected: "Pattern Rilevato",
    stat_anomaly: "Anomalia Statistica",
  },
  matches: {
    title: "Incontri",
    subtitle: "Tutti i match Tennis e Tennistavolo",
    all: "Tutti",
    live: "Live",
    upcoming: "Prossimi",
    scheduled: "Programmati",
    finished: "Terminati",
    tournament: "Torneo",
    round: "Turno",
    surface: "Superficie",
    format: "Formato",
    score: "Punteggio",
    winner: "Vincitore",
    no_matches: "Nessun incontro trovato",
    detail_title: "Dettaglio Incontro",
    prematch_signals: "Segnali Prematch",
    live_signals: "Segnali Live",
    odds_history: "Storico Quote",
    score_live: "Punteggio Live",
    player_comparison: "Confronto Giocatori",
    match_info: "Informazioni Incontro",
    vs: "vs",
    serving: "Al servizio",
    current_score: "Punteggio attuale",
    set: "Set",
  },
  match_detail: {
    historical_odds: "Quote Storiche",
    prematch_analysis: "Analisi Prematch",
    live_analysis: "Analisi Live",
    player_comparison: "Confronto Giocatori",
    prematch_odds_signals: "Quote Prematch e Segnali",
    current_score_live_odds: "Punteggio Attuale e Quote Live",
    live_signals_active: "Segnali Live Attivi",
    signal_history: "Storico Segnali",
    best_prematch_angle: "Miglior Angolo Prematch",
    deep_analysis: "Analisi Approfondita",
    head_to_head: "Precedenti (H2H)",
    recent_form: "Forma Recente",
    best_live_angle: "Miglior Angolo Live",
    follow_live: "Da Seguire Live",
    high_volatility: "Match con alto potenziale di volatilita",
    no_prematch_flag: "Nessun flag prematch attivo",
    winner_label: "Vincitore",
    player_data_unavailable: "Dati giocatori non disponibili",
    no_prematch_signal: "Nessun segnale prematch",
    no_live_signal: "Nessun segnale live",
    live_odds: "Quote Live",
    // Table headers
    th_selection: "Selezione",
    th_bookmaker: "Bookmaker",
    th_odds: "Quota",
    th_implied_prob: "Prob. Impl.",
    th_set: "Set",
    th_set_score: "Set Score",
    th_type: "Tipo",
    th_market: "Mercato",
    th_fair_odds: "Quota Fair",
    th_ev_pct: "EV %",
    th_conf_mom: "Conf./Mom.",
    th_status: "Stato",
    th_time: "Ora",
    type_prematch: "Prematch",
    type_live: "Live",
    conf_label: "conf",
    mom_label: "mom",
  },
  players: {
    title: "Giocatori",
    subtitle: "Database atleti Tennis e Tennistavolo",
    all_sports: "Tutti gli sport",
    name: "Nome",
    country: "Paese",
    nationality: "Nazionalita",
    ranking: "Ranking",
    rating: "Rating",
    form_score: "Forma",
    surface_hard: "Cemento",
    surface_clay: "Terra",
    surface_grass: "Erba",
    win_rate: "% Vittorie",
    roi: "ROI",
    recent_form: "Forma Recente",
    matches_played: "Partite",
    stats: "Statistiche",
    hand: "Mano Prevalente",
    handedness: "Mano",
    height: "Altezza",
    age: "Eta",
    avg_odds: "Quota Media",
    detail_title: "Profilo Giocatore",
    recent_matches: "Partite Recenti",
    no_players: "Nessun giocatore trovato",
    matches_won: "Partite Vinte",
    win_percentage: "% Vittorie",
    last5: "Ultimi 5",
    surface_ratings: "Rating Superficie",
    search_placeholder: "Cerca giocatore...",
  },
  player_detail: {
    current_rating: "Rating Attuale",
    elo_score: "Punteggio ELO",
    recent_form: "Forma Recente",
    latest_results: "Ultimi risultati",
    dominant_hand: "Mano Dominante",
    record: "Record",
    win_rate: "vittorie",
    performance: "Rendimento Sintetico",
    wins: "Vittorie",
    avg_confidence: "Conf. Media",
    avg_ev_prematch: "EV Medio PM",
    ev_prematch_sub: "Expected Value prematch",
    no_finished_match: "Nessun match terminato",
    win_rate_label: "win rate",
    on_prematch_signals: "su {count} segnali prematch",
    on_live_signals: "media su {count} segnali live",
    // Tables
    th_opponent: "Avversario",
    th_tournament: "Torneo",
    th_sport: "Sport",
    th_date: "Data",
    th_status: "Stato",
    th_result: "Esito",
    won: "Vinto",
    lost: "Perso",
    in_progress: "In corso",
    prematch_signals: "Segnali Prematch",
    live_signals: "Segnali Live",
    no_prematch_signals: "Nessun segnale prematch per questo giocatore",
    no_live_signals: "Nessun segnale live per questo giocatore",
  },
  notifications: {
    title: "Notifiche",
    subtitle: "Alert e segnalazioni del sistema",
    all: "Tutte",
    unread: "Non lette",
    mark_read: "Segna come letta",
    mark_all_read: "Segna tutte come lette",
    type_signal: "Segnale",
    type_prematch: "Prematch",
    type_live: "Live",
    type_alert: "Alert",
    type_system: "Sistema",
    no_notifications: "Nessuna notifica",
    unread_count: "non lette",
    just_now: "Adesso",
    minutes_ago: "min fa",
    hours_ago: "ore fa",
    days_ago: "giorni fa",
  },
  settings: {
    title: "Impostazioni",
    subtitle: "Configura la tua esperienza PointEdge",
    section_prematch: "Segnali Prematch",
    section_prematch_desc: "Configura soglie e alert per i segnali prematch",
    section_live: "Segnali Live",
    section_live_desc: "Configura soglie e alert per i segnali live",
    notifications_section: "Notifiche",
    notifications_section_desc: "Gestisci i canali di notifica",
    section_preferences: "Preferenze",
    section_preferences_desc: "Personalizza la tua esperienza",
    prematch_alerts: "Abilita Alert Prematch",
    prematch_alerts_desc: "Ricevi notifiche quando vengono rilevati segnali prematch di valore",
    live_alerts: "Abilita Alert Live",
    live_alerts_desc: "Ricevi notifiche per segnali live e cambi momentum",
    in_app_alerts: "Alert In-App",
    in_app_alerts_desc: "Mostra notifiche all'interno dell'applicazione",
    telegram_alerts: "Alert Telegram",
    telegram_alerts_desc: "Ricevi notifiche tramite Telegram",
    email_alerts: "Alert Email",
    email_alerts_desc: "Ricevi notifiche via email",
    coming_soon: "Prossimamente",
    thresholds_section: "Soglie di Filtro",
    min_ev_prematch: "Soglia Minima EV Prematch",
    min_ev_prematch_desc: "Soglia minima Expected Value per generare segnali prematch",
    min_ev_live: "Soglia Minima EV Live",
    min_ev_live_desc: "Soglia minima Expected Value per generare segnali live",
    min_confidence: "Confidenza Minima",
    min_confidence_desc: "Filtra segnali prematch per livello di confidenza minimo",
    min_momentum: "Momentum Minimo",
    min_momentum_desc: "Soglia minima momentum score per segnali live",
    sports_section: "Sport Preferito",
    favorite_sport: "Sport Preferito",
    favorite_sport_desc: "Mostra prioritariamente segnali di questo sport",
    language_section: "Lingua",
    language: "Lingua Interfaccia",
    language_it: "Italiano",
    theme: "Tema",
    theme_dark: "Scuro",
    save_success: "Impostazioni aggiornate",
    save_error: "Errore nel salvataggio delle impostazioni",
    save_btn: "Salva Impostazioni",
    platform_section: "Piattaforma",
    version: "Versione",
    engine_prematch: "Engine Prematch",
    engine_live: "Engine Live",
    status_active: "Attivo",
  },
  admin: {
    title: "Pannello Admin",
    subtitle: "Gestione sistema e monitoraggio",
    auth_title: "Accesso Admin",
    auth_subtitle: "Inserisci il PIN per accedere al pannello di amministrazione",
    pin_placeholder: "PIN Admin",
    login_btn: "Accedi",
    invalid_pin: "PIN non valido",
    logout: "Esci",
    system_status: "Stato Sistema",
    data_mode: "Modalita Dati",
    provider_status: "Stato Provider",
    record_counts: "Conteggi Record",
    last_sync: "Ultimo Sync",
    sync_btn: "Esegui Sync",
    sync_running: "Sincronizzazione...",
    mode_mock: "Mock (Demo)",
    mode_external: "Esterni",
    available: "Disponibile",
    unavailable: "Non disponibile",
    source: "Sorgente",
    records: "Record",
    error_logs: "Log Errori",
    error_logs_subtitle: "Monitoraggio errori e attivita del sistema",
    clear_logs: "Cancella Log",
    no_logs: "Nessun log disponibile",
    level_error: "Errore",
    level_warning: "Avviso",
    level_info: "Info",
    log_source: "Sorgente",
    log_message: "Messaggio",
    log_time: "Ora",
    filter_all: "Tutti",
    never: "Mai",
    success: "Successo",
    error: "Errore",
    provider_player_data: "Dati Giocatori",
    provider_match_schedule: "Calendario Incontri",
    provider_prematch_odds: "Quote Prematch",
    provider_live_score: "Punteggi Live",
    provider_live_odds: "Quote Live",
    quota_best: "Migliore",
    quota_worst: "Peggiore",
    scores24_last_scrape: "Ultimo scrape",
    scores24_matches: "Match Tennistavolo",
    scores24_odds: "Quote Tennistavolo",
    the_odds_api_configured: "The Odds API",
    hybrid_mode: "Ibrido (Tennis esterno + TT scrape)",
    sync_result_tennis: "Tennis",
    sync_result_table_tennis: "Tennistavolo",
  },
  screenshot: {
    title: "Confronta Quote",
    subtitle: "Carica screenshot di un sito ADM per confrontare le quote con il modello PointEdge",
    upload_title: "Carica Screenshot",
    upload_desc: "Trascina o clicca per caricare uno screenshot delle quote dal tuo bookmaker",
    upload_formats: "PNG, JPEG, WEBP (max 10MB)",
    analyzing: "Analisi in corso...",
    analyzing_desc: "GPT-4o sta estraendo le quote dallo screenshot...",
    results_title: "Risultati Confronto",
    bookmaker: "Bookmaker ADM",
    extracted: "Partite estratte",
    matched: "Match trovati nel DB",
    with_value: "Con valore positivo",
    no_matches: "Nessuna partita estratta dallo screenshot. Riprova con un'immagine più chiara.",
    no_db_match: "Nessun match trovato nel database. Assicurati che le partite siano state sincronizzate.",
    col_match: "Match",
    col_tournament: "Torneo",
    col_adm_odds: "Quote ADM",
    col_betsapi_odds: "Quote BetsAPI",
    col_fair_odds: "Fair Odds",
    col_ev_adm: "EV% ADM",
    col_ev_betsapi: "EV% BetsAPI",
    col_confidence: "Conf.",
    value_found: "VALORE",
    no_value: "No Value",
    unmatched_title: "Partite non abbinate",
    unmatched_desc: "Queste partite non sono state trovate nel database PointEdge",
    retry: "Carica altro screenshot",
    upload_another: "Confronta altro",
  },
};

export default it;
